<script lang="ts" setup>
import AppMenuItem from './AppMenuItem.vue'
import { workspaceLink, workspaceMenu } from '~/utils/workspaceNavigation'

const route = useRoute()
const { currentOrganization, organizationCounts } = useOrganization()
const { hasWorkspaceAccess } = useAuth()

const model = computed(() =>
  workspaceMenu
    .map((group) => ({
      label: group.label,
      items: (group.label === 'Campaigns' &&
      hasWorkspaceAccess('blast_history') &&
      !hasWorkspaceAccess('campaigns')
        ? [
            ...group.items,
            {
              label: 'Blast history',
              to: '/comms/blasts',
              icon: 'pi-send',
              access: 'blast_history' as const,
              count: undefined,
            },
          ]
        : group.items
      )
        .filter(({ access, count }) => {
          // Hide QuickBooks payments when QuickBooks was never connected (or disconnected on purpose).
          // A broken connection stays visible with a red "!".
          if (
            count === 'quickbooks_payments' &&
            organizationCounts.value &&
            organizationCounts.value.quickbooks_health == null
          )
            return false
          if (!access) return true
          return !!currentOrganization.value && hasWorkspaceAccess(access)
        })
        .map((item) => ({
          ...item,
          icon: 'pi pi-fw ' + item.icon,
          badge:
            item.count === 'quickbooks_payments' &&
            organizationCounts.value?.quickbooks_health === 'error'
              ? '!'
              : item.count
                ? organizationCounts.value?.[item.count] || undefined
                : undefined,
          badgeSeverity: item.count ? 'danger' : undefined,
        })),
    }))
    .filter((group) => group.items.length)
)

const activeMenuTo = computed(
  () => workspaceLink(route.fullPath, model.value)?.item.to
)
provide('activeMenuTo', activeMenuTo)
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="i">
      <app-menu-item :item="item" :index="i"></app-menu-item>
    </template>
  </ul>
</template>
